import { scan } from "react-scan"; // must be imported before React and React DOM
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import GlobalStateProvider from './contexts/globalStateProvider';

function render() {
  const container = document.getElementById('root');
  const root = ReactDOM.createRoot(container!);

  scan({
    enabled: process.env.NODE_ENV === 'development' // only in development mode
  })

  // enableMockServer().then(() =>
  return root.render(
    <StrictMode>
      <GlobalStateProvider>
        <App />
      </GlobalStateProvider>
    </StrictMode>,
  )
  // )
  // createRoot(document.getElementById('root')!).render(
  //   <StrictMode>
  //     <GlobalStateProvider>
  //       <App />
  //     </GlobalStateProvider>
  //   </StrictMode>,
  // );
}
render();
